var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.8 15.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9,6.52c0.36,0,0.65,0.29,0.65,0.65v4.13c0,0.36-0.29,0.65-0.65,0.65c-0.36,0-0.65-0.29-0.65-0.65V7.16 c0-0.36,0.29-0.65,0.65-0.65V6.52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9,4.04c0.36,0,0.65,0.29,0.65,0.65S8.26,5.34,7.9,5.34c-0.36,0-0.65-0.29-0.65-0.65S7.54,4.03,7.9,4.03 V4.04z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9,1.5c3.53,0,6.4,2.87,6.4,6.4s-2.87,6.4-6.4,6.4s-6.4-2.86-6.4-6.4S4.37,1.5,7.9,1.5z M7.9,0 C3.54,0,0,3.54,0,7.9s3.54,7.9,7.9,7.9s7.9-3.54,7.9-7.9S12.27,0,7.9,0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.815b51c5dad948b1935e615c25af1f75.svg";
export { ForwardRef as ReactComponent };